import React from 'react'
import ReactImageMagnify from 'react-image-magnify';
import {useCartContext} from '../context/CartContext';
import storeItems from "../data/StoreData.json";
import FormatCurrency from './FormatCurrency';
import {useParams , Link}  from 'react-router-dom';
import IntroSections from '../IntroSections';


const Product_details = () => {
  const {getItemQuantity, increaseCartQuantity, decreaseCartQuantity, removeFromCart} = useCartContext(); 
    const {id} = useParams();
    const item = storeItems.find((i) => i.id === +id)
    const Quantity = getItemQuantity(item.id);
    return (
<>
    <IntroSections sectionName='Product Details' sectionLink='Details' /> 
            
<div key={item.id} className='Product_details'>
    <div className='container'>
        <div className='row'>
            <div className='col-lg-4 col-md-4 imge'>
                <ReactImageMagnify {...{
                    smallImage: {
                        alt: 'Wristwatch by Ted Baker London',
                        isFluidWidth: true,
                        src: item.imgUrl
                    },
                    largeImage: {
                        src: item.imgUrl,
                        width: 500,
                        height: 500
                    }
            }} />             




          
            </div>
                        

        <div className='col-lg-8 col-md-8 css'>
            <h6> Categories  ({item.categories}) </h6>
            <h3>{ item.title }</h3>
            <span>{ FormatCurrency(item.price)}  + Free Shipping </span>    
            <p>Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.</p>

             {Quantity === 0 ? <button onClick={() =>increaseCartQuantity(item.id)} className='add'> <i className="fa-solid fa-cart-shopping"></i> Add To Cart</button> : <div>
                
                <div className='addMore'>
                <button onClick={() =>increaseCartQuantity(item.id)}>+</button>   
                <span> {Quantity} In Cart</span>        
                <button onClick={() =>decreaseCartQuantity(item.id)}>-</button>        
                </div>
                    
                <button onClick={() =>removeFromCart(item.id) } className='remove '>Remove</button>
        </div> }                

        </div>
                        
<div className=' col-lg-6 col-md-6 mt-3 css' >
   <h3>Description</h3>
    <p>Since it’s creation lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>                    
    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.
    </p>                    
</div>                    

<div className=' col-lg-6 col-md-6 mt-3 css'>
<h3>
More about the product                                
  </h3>
<p>
  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in.                              
</p>

</div> 

    </div>
    </div>
</div>
</>
            )
}

export default Product_details